import React, { useState } from "react"
import { connect } from "react-redux"
import { apiRequest } from "@data/redux/actions/api"
import { useRequestOnMount } from "../common/hooks/useRequestOnMount"
import { ScreenSkeleton } from "../common/screens/ScreenSkeleton"
import { fastTrackService } from "../data/services/fastTrackService"
import { SlotPicker } from "../common/components/slot-picker/SlotPicker"

const FastTrackBookTrialSlotStep = (props) => {
    const [availableSessions, setAvailableSessions] = useState([])

    useRequestOnMount(
        props.apiRequest,
        fastTrackService.getAvailableTrialLiveSessions,
        {},
        (data) => setAvailableSessions(data)
    )

    return (
        <ScreenSkeleton
            isLoading={props.getAvailableTrialLiveSessionsRequest}
            withCenterContent
        >
            <SlotPicker
                slots={availableSessions}
                isSelected={(value) => props.selectedSession?.value === value}
                setSelectedSlot={props.setSelectedSession}
            />
        </ScreenSkeleton>
    )
}

const mapStateToProps = (state) => {
    return {
        getAvailableTrialLiveSessionsRequest:
            state.api.getAvailableTrialLiveSessions?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FastTrackBookTrialSlotStep)
